module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAn1BMVEVHcEwhISEcHBwAAAAhISEgICAhISEhISEhISEdHR0hISEfHx8gICAgICAgICAcHBwgICAhISEgICAgICAhISEhISEhISEhISEXFxccHBwdHR0hISEhISEhISEgICAhISEhISEgICAhISEhISEAAAAkJCQhISEgICAgICAdHR0cHBwgICAhISEgICAhISEhISEhISEfHx8hISEfHx8hISHQSGhJAAAANHRSTlMA6xsF6Fm76R8j2Dr9p0cJcMSlpsrJ51QLLRq60vNxtMPuez4DBy84uDQkvfL0svDZa3xq2NTBHAAAAIdJREFUKM/l0VcOAiEUheHDIDAy1d577+3sf22GxBgVduD3ckn+cB8AKK2p/DC2BG4MeuDKedVzp4VgH56IAoaxH2KaPw6CUfitmqyrN3dZdpRqsIU8/fiF0QIYu0OaA0mmXwZDnjbYT7TOku/VyzOPO4TILS/rYFkdOOsFSzFluwiWrq5JN5949xba62k5BgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pinglun.png
// module id = 4qf2
// module chunks = 1